import { API_BASE_URL } from "../../constants/index";
import { buildUrl } from "../../utilities/index";
import HttpInterface from "../../helpers/HttpInterface";

export class IncomingGoodsService {
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  all(params = {}) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      buildUrl(`${API_BASE_URL}/logistic-service/incoming-goods`, params),
      requestOptions
    );
  }

  get(id) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/incoming-goods/${id}`,
      requestOptions
    );
  }

  create(incomingGood) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(incomingGood),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/incoming-goods`,
      requestOptions
    );
  }

  edit(incomingGood) {
    const requestOptions = {
      method: "PUT",
      body: JSON.stringify(incomingGood),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/incoming-goods/${incomingGood.id}`,
      requestOptions
    );
  }

  delete(id) {
    const requestOptions = {
      method: "DELETE",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/incoming-goods/${id}`,
      requestOptions
    );
  }

  confirm(id) {
    const requestOptions = {
      method: "POST",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/incoming-goods/${id}/status/CONFIRMED`,
      requestOptions
    );
  }
}
